export interface ResellerItemMap {
  [itemId: string]: string;
}

export enum Columns {
  Product = 'product',
  Activations = 'activations',
  Deactivations = 'deactivations',
  Growth = 'growth',
  Actions = 'actions',
  ActiveAccounts = 'active accounts',
  VerticalLine = 'line',
  Cancellations = 'cancellations',
  SellingInStore = 'selling in store',
}
